<template>
  <div class="tb-list-item">
    <!-- <div class="tb-list-item-meta"> -->
    <div class="tb-list-item-meta-icon">
      <Badge :status="data.carStateIcon"></Badge>
    </div>
    <div class="tb-list-item-meta-content">
      <div class="tb-list-item-cell">
        <div class="tb-list-item-cell-l">
          {{data.companyDisplay}}
        </div>
        <div class="tb-list-item-cell-r focus" style="font-size:13px;">
          <span>No.{{data.carNo}}</span>
        </div>
      </div>
      <div class="tb-list-item-cell">
        <div class="tb-list-item-cell-l light">
          <div class="flex" style="justify-content: left;">
            <sl-tag :color="data.applyStateIcon" style="font-size:10px;opacity: 0.75">{{data.applyStateText}}</sl-tag>
            <span>{{data['category.name']}}</span>
          </div>
          <span title="车牌号" class="mask" v-if="!!data['license.licenseNo']">{{data['license.licenseNo']}}</span>
        </div>
        <div class="tb-list-item-cell-r">
          <span style="width:32px;">{{data.carStateDisplay}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  computed: {

  },
  monuted() {
    console.log(this.$props)
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.tb-list-item {
  display: flex;
  align-items: Center;
}

.tb-list-item-meta-icon {
  flex: 0 0 auto;
}

.tb-list-item-meta-content {
  flex: auto;
}

.mask{
  border: 1px solid rgba(0,0,0,.4);
  border-radius: 4px;
  padding: 2px 5px;
  font-size: 11px;
  color: #333;
  margin-right: 6px;
}

</style>
